import { Journey, privateApi, RegisterJourney, UpdateJourney } from 'services';
import { JourneyStatus } from 'lib/enum/journey-status.enum';

const registerJourney = (businessAccountId: string, journey: RegisterJourney): Promise<Journey> =>
    privateApi.post<Journey>(`business-accounts/${businessAccountId}/leads/journeys`, journey);

const updateStatus = (journeyId: string, status: JourneyStatus): Promise<void> =>
    privateApi.put<void>(`journeys/${journeyId}/status`, {
        status,
    });

const updateJourney = (journeyId: string, journey: UpdateJourney): Promise<Journey> =>
    privateApi.put<Journey>(`journeys/${journeyId}`, {
        ...journey,
    });

const uploadImage = (journeyId: string, data: FormData): Promise<void> =>
    privateApi.postMultipart(`journeys/${journeyId}/image`, data, true);

export const BusinessAccountJourneysGateway = {
    registerJourney,
    updateStatus,
    uploadImage,
    updateJourney,
};
